<template>
  <div class="page activity-rule">
    <navigation class="header">活动规则</navigation>
    <div class="body">
      <div class="section" v-for="(item, index) in rules" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="desc" v-html="item.desc">
        </div>
      </div>
    </div>
    <footer style="color: #BA8536;">活动所有解释权归天美贷所有</footer>
  </div>
</template>

<script>
export default {
  name: 'relending-rule',
  data () {
    return {
      start: Number(this.$route.query.start),
      end: Number(this.$route.query.end),
      rules: [
        {
          title: '活动对象',
          desc: '天美贷平台指定老客'
        },
        {
          title: '活动方式',
          desc: `
          <p>1、2000元专属额度：1000~2000元的临时额度，登录天美贷平台有机会可领取并使用额度</p>
          <p>2、15天专属免息券：在天美贷平台的提现成功笔数达到3笔，系统将发放一张15天免息券至您的券包；免息券有效期60天（须在25年12月30日前完成提现任务可获得）</p>
          `
        },
        {
          title: '活动说明',
          desc: '天美贷平台指天美贷APP、天美贷微信公众号、天美贷极速借小程序'
        }
      ]
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.page.activity-rule {
    background: linear-gradient( 180deg, #FF641F 0%, #FFE7BC 56%, #FFF6DC 100%);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
        flex-shrink: 0;
    }
    .body {
        flex: 1;
        flex-shrink: 0;
        margin: 40px 40px 0;
        background-color: #fff;
        border-radius: 30px;
        padding: 30px 30px 100px;
        .section {
            .title {
                padding-top: 50px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 45px;
            }
            .desc {
                border-radius: 16px;
                background-color: #fff;
                padding: 20px 0;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
                margin-top: 10px;
            }
        }
    }

    footer {
        flex-shrink: 0;
        font-size: 22px;
        color: #fff;
        text-align: center;
        margin-top: 65px;
        margin-bottom: 45px;
    }
}
</style>
